export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/Blog.8b6b2926.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};